"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ErrorDisplay", {
  enumerable: true,
  get: function get() {
    return _ComponentError.default;
  }
});

var _ComponentError = _interopRequireDefault(require("../../internal/ComponentError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/ui_elements/errors/index.js
// module id = 753
// module chunks = 0 15 16 17 18